function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_103",
  "data-name": "Rectangle 103",
  width: 283.75,
  height: 258.555,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_227",
  "data-name": "Group 227",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_949",
  "data-name": "Path 949",
  d: "M14.921,193.428h8.257c0,3.169-.649,5.425-2.569,7.2a7.814,7.814,0,0,1-5.64,2.016,8.27,8.27,0,0,1-6.145-2.376,8.069,8.069,0,0,1-2.3-5.784,8.344,8.344,0,0,1,2.4-6,8.567,8.567,0,0,1,6.217-2.352,8.555,8.555,0,0,1,4.32,1.08,7.853,7.853,0,0,1,2.857,3.288l-3.961,1.632a3.913,3.913,0,0,0-1.152-1.607,3.358,3.358,0,0,0-2.232-.793,3.865,3.865,0,0,0-2.736,1.1,5.4,5.4,0,0,0-1.393,3.672,5.008,5.008,0,0,0,1.272,3.457,3.79,3.79,0,0,0,2.929,1.224,3.428,3.428,0,0,0,2.3-.744,2.848,2.848,0,0,0,.984-1.776H14.921Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_950",
  "data-name": "Path 950",
  d: "M38.513,190.02H33.569v2.665h4.679v3.528H33.569v2.76h4.944V202.5h-9.1V186.492h9.1Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_951",
  "data-name": "Path 951",
  d: "M44.752,202.5v-16.01H48.9l7.657,9.793v-9.793h4.152V202.5H56.561L48.9,192.708V202.5Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_952",
  "data-name": "Path 952",
  d: "M76.769,190.02H71.825v2.665H76.5v3.528H71.825v2.76h4.944V202.5h-9.1V186.492h9.1Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_953",
  "data-name": "Path 953",
  d: "M89.489,186.491a5.176,5.176,0,0,1,3.912,1.416,5.273,5.273,0,0,1,1.368,3.6,4.624,4.624,0,0,1-1.272,3.337,4.482,4.482,0,0,1-2.208,1.1l5.017,6.553H91.145l-3.984-6.145V202.5H83.009v-16.01Zm-2.328,7.177h.792a3.125,3.125,0,0,0,2.016-.647,2,2,0,0,0,.528-1.345,1.888,1.888,0,0,0-.552-1.344,2.818,2.818,0,0,0-1.992-.624h-.792Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_954",
  "data-name": "Path 954",
  d: "M111.425,199.813h-5.808l-1.08,2.688h-4.393l6.145-16.009h4.536l6.024,16.009h-4.44Zm-1.1-3.168-1.8-5.185-1.753,5.185Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_955",
  "data-name": "Path 955",
  d: "M127.624,190.02V202.5h-4.152V190.02h-3.409v-3.528h10.969v3.528Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_98",
  "data-name": "Rectangle 98",
  width: 4.152,
  height: 16.01,
  transform: "translate(136.48 186.491)",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_956",
  "data-name": "Path 956",
  d: "M150.448,186.491l3.841,9.745,3.888-9.745h4.512l-6.816,16.01h-3.24l-6.721-16.01Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_957",
  "data-name": "Path 957",
  d: "M177.064,190.02h-4.945v2.665h4.68v3.528h-4.68v2.76h4.945V202.5h-9.1V186.492h9.1Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_958",
  "data-name": "Path 958",
  d: "M193.551,197.7a5.6,5.6,0,0,0,3.672,1.633,2.1,2.1,0,0,0,1.608-.553,1.425,1.425,0,0,0,.408-1.008,1.252,1.252,0,0,0-.456-.96,5.764,5.764,0,0,0-2.064-.84l-1.08-.335a5.241,5.241,0,0,1-2.3-1.3,4.028,4.028,0,0,1-.912-2.832,5.238,5.238,0,0,1,1.464-3.865,5.644,5.644,0,0,1,4.1-1.511,11.249,11.249,0,0,1,4.945,1.3l-1.656,3.24a4.221,4.221,0,0,0-2.737-1.08,1.989,1.989,0,0,0-1.368.48,1.183,1.183,0,0,0-.408.863,1.074,1.074,0,0,0,.217.721,2.617,2.617,0,0,0,1.391.72l1.273.384a6.124,6.124,0,0,1,2.9,1.584,3.785,3.785,0,0,1,1.032,2.856,5.42,5.42,0,0,1-1.512,4.032,6.21,6.21,0,0,1-4.729,1.633,8.577,8.577,0,0,1-3.144-.528,11.2,11.2,0,0,1-2.424-1.273Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_959",
  "data-name": "Path 959",
  d: "M224.224,200.485a9.57,9.57,0,0,1-12.625,0,8.373,8.373,0,0,1,0-11.977,9.573,9.573,0,0,1,12.625,0,8.375,8.375,0,0,1,0,11.977m-9.553-9.049a4.392,4.392,0,0,0-1.272,3.145,4.065,4.065,0,0,0,1.272,2.976,4.542,4.542,0,0,0,3.24,1.273,4.351,4.351,0,0,0,4.513-4.322,4.322,4.322,0,0,0-1.3-3.072,4.791,4.791,0,0,0-3.216-1.271,4.614,4.614,0,0,0-3.24,1.271",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_960",
  "data-name": "Path 960",
  d: "M237.134,186.491v9.481a3.236,3.236,0,0,0,.816,2.472,2.948,2.948,0,0,0,3.889.072,3.5,3.5,0,0,0,.936-2.9v-9.121h4.152v9.193a6.5,6.5,0,0,1-1.8,5.185,6.913,6.913,0,0,1-5.28,1.992,7.146,7.146,0,0,1-5.3-1.921,7.471,7.471,0,0,1-1.56-5.256v-9.193Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_961",
  "data-name": "Path 961",
  d: "M258.039,186.491v12.481h4.993V202.5h-9.145v-16.01Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_962",
  "data-name": "Path 962",
  d: "M269.222,197.7a5.6,5.6,0,0,0,3.672,1.633,2.1,2.1,0,0,0,1.608-.553,1.426,1.426,0,0,0,.408-1.008,1.252,1.252,0,0,0-.456-.96,5.765,5.765,0,0,0-2.064-.84l-1.08-.335a5.241,5.241,0,0,1-2.3-1.3,4.028,4.028,0,0,1-.912-2.832,5.238,5.238,0,0,1,1.464-3.865,5.644,5.644,0,0,1,4.1-1.511,11.249,11.249,0,0,1,4.945,1.3l-1.656,3.24a4.221,4.221,0,0,0-2.737-1.08,1.989,1.989,0,0,0-1.368.48,1.183,1.183,0,0,0-.408.863,1.074,1.074,0,0,0,.217.721,2.617,2.617,0,0,0,1.391.72l1.273.384a6.124,6.124,0,0,1,2.9,1.584,3.785,3.785,0,0,1,1.032,2.856,5.42,5.42,0,0,1-1.512,4.032,6.21,6.21,0,0,1-4.729,1.633,8.577,8.577,0,0,1-3.144-.528,11.2,11.2,0,0,1-2.424-1.273Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_963",
  "data-name": "Path 963",
  d: "M53.888,54.236H49.966l-.728,1.814H46.272L50.42,45.242h3.063L57.55,56.05h-3Zm-.745-2.14-1.216-3.5-1.182,3.5Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_964",
  "data-name": "Path 964",
  d: "M78.433,55.758A6.678,6.678,0,0,1,76,56.293a5.878,5.878,0,0,1-4.181-1.62,5.674,5.674,0,0,1-1.637-3.938A5.671,5.671,0,0,1,75.9,45.063a6.7,6.7,0,0,1,2.528.551v3.355a3.014,3.014,0,0,0-2.447-1.184,2.742,2.742,0,0,0-1.945.713,3.018,3.018,0,0,0-.94,2.221,2.987,2.987,0,0,0,.875,2.106,3.019,3.019,0,0,0,2.01.745,3.173,3.173,0,0,0,2.447-1.133Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_965",
  "data-name": "Path 965",
  d: "M94,54.688a6.461,6.461,0,0,1-8.524,0,5.655,5.655,0,0,1,0-8.086A6.464,6.464,0,0,1,94,46.6a5.655,5.655,0,0,1,0,8.086m-6.45-6.109a2.963,2.963,0,0,0-.858,2.123,2.751,2.751,0,0,0,.858,2.01,3.069,3.069,0,0,0,2.188.858,2.936,2.936,0,0,0,3.046-2.917,2.917,2.917,0,0,0-.875-2.074,3.237,3.237,0,0,0-2.171-.858,3.115,3.115,0,0,0-2.188.858",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_966",
  "data-name": "Path 966",
  d: "M104.336,45.241v8.427h3.371V56.05h-6.175V45.241Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_967",
  "data-name": "Path 967",
  d: "M116,45.241v8.427h3.37V56.05H113.2V45.241Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_968",
  "data-name": "Path 968",
  d: "M131,47.623h-3.338v1.8h3.16V51.8h-3.16v1.864H131V56.05h-6.142V45.241H131Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_969",
  "data-name": "Path 969",
  d: "M144.6,55.758a6.669,6.669,0,0,1-2.43.535,5.878,5.878,0,0,1-4.181-1.62,5.674,5.674,0,0,1-1.637-3.938,5.671,5.671,0,0,1,5.721-5.672,6.7,6.7,0,0,1,2.527.551v3.355a3.011,3.011,0,0,0-2.446-1.184,2.742,2.742,0,0,0-1.945.713,3.018,3.018,0,0,0-.94,2.221,2.987,2.987,0,0,0,.875,2.106,3.019,3.019,0,0,0,2.01.745,3.17,3.17,0,0,0,2.446-1.133Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_970",
  "data-name": "Path 970",
  d: "M154.915,47.623V56.05h-2.8V47.623h-2.3V45.241h7.406v2.382Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_99",
  "data-name": "Rectangle 99",
  width: 2.803,
  height: 10.809,
  transform: "translate(162.513 45.241)",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_971",
  "data-name": "Path 971",
  d: "M181.372,54.688a6.46,6.46,0,0,1-8.523,0,5.655,5.655,0,0,1,0-8.086,6.463,6.463,0,0,1,8.523,0,5.653,5.653,0,0,1,0,8.086m-6.449-6.109a2.963,2.963,0,0,0-.858,2.123,2.751,2.751,0,0,0,.858,2.01,3.069,3.069,0,0,0,2.188.858,2.936,2.936,0,0,0,3.046-2.917,2.917,2.917,0,0,0-.875-2.074,3.237,3.237,0,0,0-2.171-.858,3.114,3.114,0,0,0-2.188.858",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_972",
  "data-name": "Path 972",
  d: "M188.9,56.05V45.241h2.8l5.17,6.612V45.241h2.8V56.05h-2.8l-5.17-6.611V56.05Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_973",
  "data-name": "Path 973",
  d: "M223.559,54.688a6.46,6.46,0,0,1-8.523,0,5.655,5.655,0,0,1,0-8.086,6.463,6.463,0,0,1,8.523,0,5.653,5.653,0,0,1,0,8.086m-6.449-6.109a2.963,2.963,0,0,0-.858,2.123,2.751,2.751,0,0,0,.858,2.01,3.069,3.069,0,0,0,2.188.858,2.936,2.936,0,0,0,3.046-2.917,2.917,2.917,0,0,0-.875-2.074,3.237,3.237,0,0,0-2.171-.858,3.114,3.114,0,0,0-2.188.858",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_974",
  "data-name": "Path 974",
  d: "M237.281,47.623h-3.387v1.8h3.079V51.8h-3.079V56.05h-2.8V45.241h6.189Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_975",
  "data-name": "Path 975",
  d: "M10.135,162.791l-.239-.119a9.514,9.514,0,0,1,3.339-7.154v-.239a7.8,7.8,0,0,1-3.577-6.558c0-4.769,3.935-8.345,8.346-9.3l.239.357a7.333,7.333,0,0,0-1.67,4.65c0,3.1,3.1,4.651,5.724,4.651,11.208,0,16.573-9.063,18.6-18.362a27.314,27.314,0,0,1-9.658,1.789c-12.52,0-21.462-8.109-23.489-18.72A10.219,10.219,0,0,0,0,105.321v-.477a10.219,10.219,0,0,0,7.75-8.465c2.027-10.612,10.969-18.72,23.489-18.72S52.7,85.767,54.728,96.379a10.219,10.219,0,0,0,7.75,8.465v.477c-3.816,1.073-7.393,3.458-7.75,8.466-1.55,23.488-7.869,44.473-32.908,46.977-8.824.834-11.685,2.027-11.685,2.027M31.239,87.2c-6.2,0-10.85,3.338-10.85,9.181,0,5.007,2.861,7.392,6.558,8.465v.477c-3.7,1.073-6.558,3.458-6.558,8.466,0,5.842,4.65,9.181,10.85,9.181s10.85-3.339,10.85-9.181c0-5.008-2.742-7.393-6.558-8.466v-.477c3.816-1.073,6.558-3.458,6.558-8.465,0-5.843-4.65-9.181-10.85-9.181",
  fill: "#ff5436"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_976",
  "data-name": "Path 976",
  d: "M69.086,144.335c3.931,0,7.769,2.9,7.769,10.108s-4.586,13.573-12.542,15.819l-.656-1.5c4.025-2.808,6.646-6.739,6.646-11.232a10.124,10.124,0,0,1-1.217.094,6.646,6.646,0,0,1,0-13.291",
  fill: "#ff5436"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_977",
  "data-name": "Path 977",
  d: "M135.069,77.183l.239.119a9.517,9.517,0,0,1-3.339,7.155v.238a7.8,7.8,0,0,1,3.577,6.558c0,4.769-3.935,8.346-8.346,9.3l-.239-.357a7.333,7.333,0,0,0,1.67-4.65c0-3.1-3.1-4.65-5.724-4.65-11.208,0-16.573,9.062-18.6,18.361a27.314,27.314,0,0,1,9.658-1.788c12.52,0,21.462,8.108,23.489,18.72a10.219,10.219,0,0,0,7.75,8.465v.477a10.219,10.219,0,0,0-7.75,8.465c-2.027,10.613-10.969,18.72-23.489,18.72S92.5,154.208,90.476,143.6a10.219,10.219,0,0,0-7.75-8.465v-.477c3.816-1.073,7.392-3.458,7.75-8.465,1.551-23.489,7.869-44.474,32.908-46.977,8.824-.835,11.685-2.028,11.685-2.028m-21.1,75.593c6.2,0,10.85-3.338,10.85-9.181,0-5.007-2.861-7.392-6.558-8.465v-.477c3.7-1.073,6.558-3.458,6.558-8.465,0-5.843-4.65-9.182-10.85-9.182s-10.85,3.339-10.85,9.182c0,5.007,2.742,7.392,6.558,8.465v.477c-3.816,1.073-6.558,3.458-6.558,8.465,0,5.843,4.65,9.181,10.85,9.181",
  fill: "#ff5436"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_978",
  "data-name": "Path 978",
  d: "M204.341,77.183l.239.119a9.519,9.519,0,0,1-3.338,7.155v.238a7.8,7.8,0,0,1,3.576,6.558c0,4.769-3.935,8.346-8.346,9.3l-.238-.357a7.338,7.338,0,0,0,1.669-4.65c0-3.1-3.1-4.65-5.723-4.65-11.208,0-16.574,9.062-18.6,18.361a27.309,27.309,0,0,1,9.657-1.788c12.52,0,21.462,8.108,23.489,18.72a10.222,10.222,0,0,0,7.75,8.465v.477a10.222,10.222,0,0,0-7.75,8.465c-2.027,10.613-10.969,18.72-23.489,18.72s-21.461-8.107-23.488-18.72A10.222,10.222,0,0,0,152,135.13v-.477c3.815-1.073,7.392-3.458,7.75-8.465,1.55-23.489,7.869-44.474,32.908-46.977,8.823-.835,11.684-2.028,11.684-2.028m-21.1,75.593c6.2,0,10.851-3.338,10.851-9.181,0-5.007-2.862-7.392-6.558-8.465v-.477c3.7-1.073,6.558-3.458,6.558-8.465,0-5.843-4.651-9.182-10.851-9.182s-10.85,3.339-10.85,9.182c0,5.007,2.743,7.392,6.558,8.465v.477c-3.815,1.073-6.558,3.458-6.558,8.465,0,5.843,4.651,9.181,10.85,9.181",
  fill: "#ff5436"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_979",
  "data-name": "Path 979",
  d: "M273.615,77.183l.239.119a9.519,9.519,0,0,1-3.338,7.155v.238a7.8,7.8,0,0,1,3.576,6.558c0,4.769-3.935,8.346-8.346,9.3l-.238-.357a7.338,7.338,0,0,0,1.669-4.65c0-3.1-3.1-4.65-5.723-4.65-11.208,0-16.574,9.062-18.6,18.361a27.309,27.309,0,0,1,9.657-1.788c12.52,0,21.462,8.108,23.489,18.72a10.222,10.222,0,0,0,7.75,8.465v.477A10.222,10.222,0,0,0,276,143.6c-2.027,10.613-10.969,18.72-23.489,18.72s-21.461-8.107-23.488-18.72a10.222,10.222,0,0,0-7.75-8.465v-.477c3.815-1.073,7.392-3.458,7.75-8.465,1.55-23.489,7.869-44.474,32.908-46.977,8.823-.835,11.684-2.028,11.684-2.028m-21.1,75.593c6.2,0,10.851-3.338,10.851-9.181,0-5.007-2.862-7.392-6.558-8.465v-.477c3.7-1.073,6.558-3.458,6.558-8.465,0-5.843-4.651-9.182-10.851-9.182s-10.85,3.339-10.85,9.182c0,5.007,2.743,7.392,6.558,8.465v.477c-3.815,1.073-6.558,3.458-6.558,8.465,0,5.843,4.651,9.181,10.85,9.181",
  fill: "#ff5436"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_980",
  "data-name": "Path 980",
  d: "M18.164,226.269a7.76,7.76,0,0,1-2.827.621,6.831,6.831,0,0,1-4.861-1.884,6.591,6.591,0,0,1-1.9-4.579,6.6,6.6,0,0,1,6.652-6.6,7.785,7.785,0,0,1,2.94.641v3.9A3.5,3.5,0,0,0,15.318,217a3.181,3.181,0,0,0-2.261.829,3.509,3.509,0,0,0-1.093,2.581,3.467,3.467,0,0,0,1.018,2.45,3.507,3.507,0,0,0,2.336.867,3.69,3.69,0,0,0,2.846-1.319Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_981",
  "data-name": "Path 981",
  d: "M34.507,224.5h-4.56l-.849,2.111H25.65l4.824-12.57h3.562l4.729,12.57H35.28Zm-.867-2.487-1.414-4.071-1.375,4.071Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_982",
  "data-name": "Path 982",
  d: "M50.078,222.443v4.165h-3.26v-12.57h5.2a4.327,4.327,0,0,1,3.185,1.131,3.9,3.9,0,0,1,1.168,3.053,4.087,4.087,0,0,1-1.111,3.128,4.187,4.187,0,0,1-3.129,1.093Zm0-2.638h1.093a2.131,2.131,0,0,0,1.376-.4,1.437,1.437,0,0,0,.414-1.15,1.521,1.521,0,0,0-.377-1.13,1.914,1.914,0,0,0-1.394-.452H50.078Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_983",
  "data-name": "Path 983",
  d: "M69.738,216.809v9.8h-3.26v-9.8H63.8v-2.771h8.612v2.771Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_984",
  "data-name": "Path 984",
  d: "M83.725,214.038v7.443a2.543,2.543,0,0,0,.641,1.942,2.318,2.318,0,0,0,3.053.056,2.755,2.755,0,0,0,.735-2.28v-7.161h3.26v7.218A5.1,5.1,0,0,1,90,225.326a5.427,5.427,0,0,1-4.146,1.564,5.611,5.611,0,0,1-4.164-1.507,5.865,5.865,0,0,1-1.225-4.127v-7.218Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_985",
  "data-name": "Path 985",
  d: "M105.742,214.038a4.061,4.061,0,0,1,3.072,1.112,4.138,4.138,0,0,1,1.074,2.827,3.626,3.626,0,0,1-1,2.619,3.511,3.511,0,0,1-1.734.867l3.939,5.145h-4.052l-3.128-4.825v4.825h-3.26v-12.57Zm-1.828,5.635h.622a2.45,2.45,0,0,0,1.583-.509,1.566,1.566,0,0,0,.415-1.055,1.485,1.485,0,0,0-.434-1.056,2.214,2.214,0,0,0-1.564-.489h-.622Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_986",
  "data-name": "Path 986",
  d: "M126.212,216.809H122.33V218.9H126v2.769H122.33v2.167h3.882v2.771H119.07v-12.57h7.142Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_987",
  "data-name": "Path 987",
  d: "M134.885,226.608v-12.57h4.278a7.013,7.013,0,0,1,4.994,1.734,6.139,6.139,0,0,1,1.752,4.579,5.792,5.792,0,0,1-1.639,4.353,6.826,6.826,0,0,1-4.825,1.9Zm3.26-2.771h.66a3.753,3.753,0,0,0,2.751-.9,3.425,3.425,0,0,0,.961-2.582,3.757,3.757,0,0,0-.98-2.751,3.66,3.66,0,0,0-2.6-.791h-.792Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_988",
  "data-name": "Path 988",
  d: "M176.9,225.024a7.514,7.514,0,0,1-9.912,0,6.574,6.574,0,0,1,0-9.4,7.517,7.517,0,0,1,9.912,0,6.574,6.574,0,0,1,0,9.4m-7.5-7.1a3.444,3.444,0,0,0-1,2.469,3.2,3.2,0,0,0,1,2.337,3.569,3.569,0,0,0,2.544,1,3.416,3.416,0,0,0,3.543-3.393,3.394,3.394,0,0,0-1.018-2.412,3.764,3.764,0,0,0-2.525-1,3.62,3.62,0,0,0-2.544,1",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_989",
  "data-name": "Path 989",
  d: "M187.551,226.608V214.039h3.26l6.011,7.688v-7.688h3.26v12.569h-3.26l-6.011-7.688v7.688Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_990",
  "data-name": "Path 990",
  d: "M227.511,216.809h-3.938V218.9h3.581v2.769h-3.581v4.938h-3.26v-12.57h7.2Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_100",
  "data-name": "Rectangle 100",
  width: 3.26,
  height: 12.569,
  transform: "translate(236.052 214.039)",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_991",
  "data-name": "Path 991",
  d: "M251.809,214.038v9.8h3.92v2.77h-7.18V214.038Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_992",
  "data-name": "Path 992",
  d: "M263.441,226.608l2.129-12.569h3.223l2.544,6.709,2.7-6.709h3.26l1.884,12.569h-3.26l-.923-7.236-3.034,7.236h-1.3l-2.9-7.236-1.074,7.236Z",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_993",
  "data-name": "Path 993",
  d: "M5.077,50c-.288-.191-.528-.383-.528-.479,0-.144.192-.241.911-.1a19.4,19.4,0,0,0,9.593-1.152c.24-.095.479-.288.624-.288a1.351,1.351,0,0,1,.624.288c1.677,1.1,4.22,1.679,9.879,1.344,3.261-.192,6.523.959,7.961,2.3.241.24.384.431.384.528s-.24,0-.576-.192a10.24,10.24,0,0,0-5.754-1.583c-3.742,0-6.907,1.919-13.238,1.919A18.523,18.523,0,0,1,5.077,50",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_994",
  "data-name": "Path 994",
  d: "M269.066,52.591c-6.332,0-9.5-1.919-13.238-1.919a10.243,10.243,0,0,0-5.754,1.583c-.337.192-.576.288-.576.192s.143-.288.383-.528c1.439-1.343,4.7-2.494,7.961-2.3,5.66.335,8.2-.24,9.88-1.344a1.336,1.336,0,0,1,.624-.288c.144,0,.384.193.623.288a19.406,19.406,0,0,0,9.594,1.151c.718-.144.91-.047.91.1,0,.1-.24.287-.527.478a18.526,18.526,0,0,1-9.88,2.591",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_101",
  "data-name": "Rectangle 101",
  width: 23.003,
  height: 1.934,
  transform: "translate(131.374 254.425) rotate(-23.117)",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_995",
  "data-name": "Path 995",
  d: "M131.011,255.333a1.678,1.678,0,1,0,2.2.885,1.678,1.678,0,0,0-2.2-.885",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_996",
  "data-name": "Path 996",
  d: "M129.008,253.661a1.678,1.678,0,1,0,2.183-.931,1.678,1.678,0,0,0-2.183.931",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_997",
  "data-name": "Path 997",
  d: "M152.8,246.04a1.678,1.678,0,1,0,2.2.885,1.678,1.678,0,0,0-2.2-.885",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_998",
  "data-name": "Path 998",
  d: "M150.8,244.369a1.678,1.678,0,1,0,2.183-.931,1.678,1.678,0,0,0-2.183.931",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_102",
  "data-name": "Rectangle 102",
  width: 1.934,
  height: 23.003,
  transform: "translate(130.734 247.173) rotate(-66.883)",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_999",
  "data-name": "Path 999",
  d: "M153.011,255.333a1.678,1.678,0,1,1-2.2.885,1.678,1.678,0,0,1,2.2-.885",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1000",
  "data-name": "Path 1000",
  d: "M155.014,253.661a1.678,1.678,0,1,1-2.183-.931,1.678,1.678,0,0,1,2.183.931",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1001",
  "data-name": "Path 1001",
  d: "M131.224,246.04a1.678,1.678,0,1,1-2.2.885,1.678,1.678,0,0,1,2.2-.885",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1002",
  "data-name": "Path 1002",
  d: "M133.227,244.369a1.678,1.678,0,1,1-2.183-.931,1.679,1.679,0,0,1,2.183.931",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1003",
  "data-name": "Path 1003",
  d: "M139.027,23.582h-.71a.258.258,0,0,1-.24-.164l-.539-1.384h2.269l-.54,1.384a.257.257,0,0,1-.24.164",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1004",
  "data-name": "Path 1004",
  d: "M141.253,23.582h-.71a.258.258,0,0,1-.24-.164l-.539-1.384h2.269l-.54,1.384a.257.257,0,0,1-.24.164",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1005",
  "data-name": "Path 1005",
  d: "M143.479,23.582h-.71a.258.258,0,0,1-.24-.164l-.539-1.384h2.269l-.54,1.384a.257.257,0,0,1-.24.164",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1006",
  "data-name": "Path 1006",
  d: "M145.705,23.582h-.71a.258.258,0,0,1-.24-.164l-.539-1.384h2.269l-.54,1.384a.257.257,0,0,1-.24.164",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1007",
  "data-name": "Path 1007",
  d: "M142.011,0a10.552,10.552,0,1,0,10.552,10.552A10.552,10.552,0,0,0,142.011,0m-5.1,16.719A3.288,3.288,0,1,1,140.2,13.43a3.288,3.288,0,0,1-3.289,3.289m5.057,2.219a.946.946,0,1,1,.946-.946.947.947,0,0,1-.946.946m5.143-2.219A3.288,3.288,0,1,1,150.4,13.43a3.289,3.289,0,0,1-3.289,3.289",
  fill: "#76ff80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1008",
  "data-name": "Path 1008",
  d: "M146.984,22.1h-9.946a.257.257,0,0,1-.247-.184l-.963-3.235,4.373.746h3.88l4.113-.746-.963,3.235a.257.257,0,0,1-.247.184",
  fill: "#76ff80"
}));

function SvgCollectionInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_228",
    "data-name": "Group 228",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 283.75,
    height: 258.555,
    viewBox: "0 0 283.75 258.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionInfo);
export default __webpack_public_path__ + "static/media/collection-info.2bc71731d1c212fb5dbe9316f3b1a0f9.svg";
export { ForwardRef as ReactComponent };